const d = "X-Request-ID", a = (e) => {
  e.headers.has(d) || e.headers.append(d, crypto.randomUUID()), e.headers.get(d) || e.headers.delete(d);
}, s = (e) => {
  e.headers.has(d) && e.headers.delete(d);
};
export {
  d as XRequestIdHeader,
  a as addRequestId,
  s as removeRequestId
};
